import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  templateUrl: "./tour-profile-submenu.component.html",
})
export class TourProfileSubmenuComponent {
  public temp;
  constructor(private activatedRoute: ActivatedRoute) {
    this.temp = this.activatedRoute.snapshot.paramMap.get("temp");
  }
}
